/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dd_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. The total-days figure is exclusive — it counts full days elapsed between the start and end date, not the end date itself. For example, 2025-01-01 to 2025-01-31 comes out to 30 days. For an inclusive count (treating both dates as counted, e.g. for a booking), add 1 day to the total.`)
};

const es_dd_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. La cifra total de días es exclusiva — cuenta los días completos transcurridos entre la fecha de inicio y final, no la fecha final en sí. Por ejemplo, de 2025-01-01 a 2025-01-31 resulta en 30 días. Para un recuento inclusivo (tratando ambas fechas como contadas, p. ej. para una reserva), suma 1 día al total.`)
};

const de_dd_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein. Die Gesamttageszahl ist exklusiv — sie zählt volle Tage, die zwischen Anfangs- und Enddatum verstrichen sind, nicht das Enddatum selbst. Zum Beispiel, 2025-01-01 bis 2025-01-31 ergibt 30 Tage. Für eine inklusive Zählung (beide Daten als gezählt behandelnd, z.B. für eine Buchung), addieren Sie 1 Tag zur Gesamtzahl.`)
};

const nl_dd_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee. Het totaal-dagen-getal is exclusief — het telt volledige verstreken dagen tussen de start- en einddatum, niet de einddatum zelf. Bijvoorbeeld, 2025-01-01 tot 2025-01-31 komt neer op 30 dagen. Voor een inclusief aantal (waarbij je beide datums telt, bijv. voor een boeking), tel je 1 dag op bij het totaal.`)
};

const fr_dd_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non. Le chiffre des jours totaux est exclusif — il compte les jours complets écoulés entre la date de début et la date de fin, pas la date de fin elle-même. Par exemple, 2025-01-01 à 2025-01-31 donne 30 jours. Pour un décompte inclusif (traitant les deux dates comme comptées, par exemple pour une réservation), ajoutez 1 jour au total.`)
};

const it_dd_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Il numero di giorni totali è esclusivo — conta i giorni interi trascorsi tra la data di inizio e quella di fine, non la data di fine stessa. Ad esempio, da 2025-01-01 a 2025-01-31 risulta 30 giorni. Per un conteggio inclusivo (trattando entrambe le date come contate, ad es. per una prenotazione), aggiungi 1 giorno al totale.`)
};

const pt_br2_dd_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. O valor total de dias é exclusivo — conta dias inteiros decorridos entre a data inicial e final, não a data final em si. Por exemplo, de 2025-01-01 a 2025-01-31 totaliza 30 dias. Para uma contagem inclusiva (tratando ambas as datas como contadas, por exemplo, para uma reserva), adicione 1 dia ao total.`)
};

const pt_dd_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. O valor do total de dias é exclusivo — conta os dias completos decorridos entre a data de início e a data de fim, não a data de fim em si. Por exemplo, 2025-01-01 a 2025-01-31 resulta em 30 dias. Para uma contagem inclusiva (tratando ambas as datas como contadas, por exemplo, para uma reserva), adicione 1 dia ao total.`)
};

const ja_dd_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。総日数の図は排他的です — それは開始日と終了日の間の経過した完全な日数をカウントします、終了日自体ではなく。例えば、2025-01-01から2025-01-31は30日です。包含的なカウント（両方の日付をカウント、例えば予約の場合）、合計に1日を追加してください。`)
};

const zh_dd_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不包含。总天数是“不包含”式的计算——它统计的是开始日期和结束日期之间经过的完整天数，不包括结束日期本身。例如，从2025-01-01到2025-01-31的结果是30天。如果需要“包含”式的计算（将两个日期都算作被统计的一天，例如用于预订场景），只需在总数上加1天。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dd_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dd_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dd_faq2_a", locale)
	if (locale === "en") return en_dd_faq2_a(inputs)
	if (locale === "es") return es_dd_faq2_a(inputs)
	if (locale === "de") return de_dd_faq2_a(inputs)
	if (locale === "nl") return nl_dd_faq2_a(inputs)
	if (locale === "fr") return fr_dd_faq2_a(inputs)
	if (locale === "it") return it_dd_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_dd_faq2_a(inputs)
	if (locale === "pt") return pt_dd_faq2_a(inputs)
	if (locale === "ja") return ja_dd_faq2_a(inputs)
	return zh_dd_faq2_a(inputs)
};